import React from "react";
import { TextField, Autocomplete } from "@mui/material";
import { FiFilter } from 'react-icons/fi';
import SearchFilterModal from "./SearchFilterModal";
import { useTranslation } from 'react-i18next';


export default function SearchFilterComp2({
  type,
  setType,
  budget,
  setBudget,
  handover,
  setHandover,
  typeOptions,
  handoverYears,
  handleBudgetChange,
  emirateOptions,
  locationSelect,
  setLocationSelect,
  developer,
  setDeveloper,
  developerOptions,
  project,
  setProject,
  projectOptions,
  inputValue,
  handleChange,
  setPage,
  setPropertyData,
  setIsLoading,
  setSearchTrigger, // ✅ RECEIVE THIS
  communityOptions,
  roomOptions,
  unitTypeOptions,
  salesStatusOptions,
  projectStatusOptions,
  projectTypeOptions,
  amenityOptions,
  setSalesStatus,
  salesStatus,
  setProjectType,
  projectType,
  setRooms,
  rooms,
  setCommunity,
  community,
  setFacility,
  facility,
  setRentalGuarantee,
  rentalGuarantee,
  setPaymentPlan,
  paymentPlan,
  setDeliveryPlan,
  deliveryPlan,
  setMinPrice,
  minPrice,
  setMaxPrice,
  maxPrice,
  setMinArea,
  minArea,
  setMaxArea,
  maxArea,
  setDownPayment,
  downPayment,
  setDeliveryDate,
  deliveryDate,
  setUnitType,
  unitType,
  isLoading,
  handleRest,
  setProjectStatus,
  projectStatus,
  setNewUnitType,
  newUnitType



}) {
  const handleSearch = () => {
    setPage(1);
    setPropertyData([]);
    setSearchTrigger(Date.now()); // ✅ Triggers re-fetch in parent
  };
  
   const { t, i18n } = useTranslation();
const isArabic = i18n.language === 'ar';


  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 max-w-7xl mx-auto">
      <h2 className="text-xl font-semibold mb-6">{t('searchFilter.perfect_property_heading')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Autocomplete
          options={typeOptions}
          value={type}
          size="small"
          onChange={(_, val) => setType(val)}
          renderInput={(params) => <TextField {...params} label={t('searchFilter.whatLookingFor')} />}
        />

        <TextField
          fullWidth
          label={t('searchFilter.budget')}
          size="small"
          value={budget}
          onChange={handleBudgetChange}
          inputProps={{ inputMode: 'numeric' }}
        />

        <Autocomplete
          options={handoverYears}
          value={handover}
          size="small"
          onChange={(_, val) => setHandover(val)}
          renderInput={(params) => <TextField {...params} label={t('searchFilter.handover')} />}
        />
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <Autocomplete
          options={emirateOptions}
          size="small"
          getOptionLabel={(option) => option.label}
          value={locationSelect}
          onChange={(_, val) => setLocationSelect(val)}
          isOptionEqualToValue={(option, value) => option.label === value?.label}
          renderInput={(params) => <TextField {...params} label={t('searchFilter.city')} fullWidth />}
        />

        <Autocomplete
          options={developerOptions}
          size="small"
          value={developer}
          onChange={(_, val) => setDeveloper(val)}
          renderInput={(params) => <TextField {...params} label={t('searchFilter.developer')} />}
        />

        <Autocomplete
          options={projectOptions}
          size="small"
          // Find the object whose label matches the stored string
          value={projectOptions.find((o) => o.label === project) || null}
          onChange={(_, val) => {
            // val is an object; store only its label
            setProject(val ? val.label : "");
          }}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => <TextField {...params} label={t('searchFilter.project')} />}
        />
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
        <TextField
          label={t('searchFilter.keywords')}
          size="small"
          multiline
          minRows={1}
          fullWidth
          value={inputValue}
          onChange={handleChange}
          placeholder={t('searchFilter.keywordsPlaceholder')}
        />
        <div>
          <SearchFilterModal
            developerOptions={developerOptions}
            developer={developer}
            setDeveloper={setDeveloper}

            projectOptions={projectOptions}
            project={project}
            setProject={setProject}

            communityOptions={communityOptions}

            roomOptions={roomOptions}
            unitTypeOptions={unitTypeOptions}
            salesStatusOptions={salesStatusOptions}
            projectStatusOptions={projectStatusOptions}
            projectTypeOptions={projectTypeOptions}
            amenityOptions={amenityOptions}
            // handleSearch={handleSearch}
            setPage={setPage}
            // setPropertyData={setPropertyData}
            setIsLoading={setIsLoading}
            // isLoading={isLoading}
            // handleSubmit={handleSubmit}
            setProjectStatus={setProjectStatus}
            projectStatus={projectStatus}
            setSalesStatus={setSalesStatus}
            salesStatus={salesStatus}
            setProjectType={setProjectType}
            projectType={projectType}
            setUnitType={setUnitType}
            unitType={unitType}
            setRooms={setRooms}
            rooms={rooms}
            setFacility={setFacility}
            facility={facility}
            setCommunity={setCommunity}
            community={community}
            setRentalGuarantee={setRentalGuarantee}
            rentalGuarantee={rentalGuarantee}
            setPaymentPlan={setPaymentPlan}
            paymentPlan={paymentPlan}
            setDeliveryPlan={setDeliveryPlan}
            deliveryPlan={deliveryPlan}
            setMinPrice={setMinPrice}
            minPrice={minPrice}
            setMaxPrice={setMaxPrice}
            maxPrice={maxPrice}
            setMinArea={setMinArea}
            minArea={minArea}
            setMaxArea={setMaxArea}
            maxArea={maxArea}
            setDownPayment={setDownPayment}
            downPayment={downPayment}
            setDeliveryDate={setDeliveryDate}
            deliveryDate={deliveryDate}
            handleSubmit={handleSearch}
            isLoading={isLoading}
            handleRest={handleRest}
            setNewUnitType={setNewUnitType}
            newUnitType={newUnitType}
          // searchTrigger={searchTrigger}
          // setSearchTrigger={setSearchTrigger}
          // community={community}
          // setCommunity={setCommunity}
          />
        </div>
        <div className="flex justify-end">
          <button
            onClick={handleSearch}
            className="bg-teal-500 hover:bg-teal-600 text-white rounded-full px-6 py-3 flex items-center justify-center gap-2"
          >
            <FiFilter className="text-lg" />
            Find Properties
          </button>
        </div>
      </div>
    </div>
  );
}
